// extracted by mini-css-extract-plugin
export default {"container":"NotificationPageTabsSkeleton_container__smb60","tab":"NotificationPageTabsSkeleton_tab__TR6aL","text":"NotificationPageTabsSkeleton_text__ZJga1"};